<template>
    <modal
        name="export-lsp-content"
        width="80%"
        :maxWidth="800"
        height="auto"
        :adaptive="true"
        :scrollable="true"
     >
        <div class="export-lsp-content">
            <div class="export-lsp-content__header">
                <span class="icon-download" />
                <h1 class="export-lsp-content__title" v-html="$t('ExportCourse.title')"></h1>
            </div>
            <ol class="export-lsp-content__list">
                <li>
                    <h2 class="export-lsp-content__subtitle" v-html="$t('ExportCourse.select_export_format')"></h2>
                    <div class="export-lsp-content__list-item">
                        <span class="export-lsp-content__description" v-html="$t('ExportCourse.select_export_format_description')"></span>
                        <ul class="export-lsp-content__radio-list">
                            <li v-for="(format, index) in lspSupportedFormats" :key="format.id">
                                <TotemRadio
                                    :label="format.name"
                                    name="format"
                                    :id="format.slug"
                                    @change="changeExportFormatValue"
                                    :value="selectedExportFormat"
                                />
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <h2 class="export-lsp-content__subtitle" v-html="$t('ExportCourse.select_ui_language')"></h2>
                    <div class="export-lsp-content__list-item">
                        <span class="export-lsp-content__description" v-html="$t('ExportCourse.select_ui_language_description')"></span>
                        <ul class="export-lsp-content__radio-list">
                            <li v-for="(language, index) in lspSupportedLanguages" :key="language.val">
                                <TotemRadio
                                    :label="getLanguageTranslation(language.name)"
                                    name="language"
                                    :id="language.countryCode"
                                    @change="changeExportLanguageValue"
                                    :value="selectedExportLanguage"
                                    />
                            </li>
                        </ul>
                    </div>
                </li>
            </ol>
            <div class="export-lsp-content__error" v-for="error in lspExportErrors">
                <span class="export-lsp-content__error-title">{{ error.field }}</span>
                <span class="export-lsp-content__error-message">{{ error.message }}</span>
            </div>
            <div class="export-lsp-content__buttons">
                <TotemButton
                    color="basic"
                    @click="hideModal"
                    class="export-lsp-content__close-button"
                    :label="$t('ExportCourse.cancel')"
                />
                <TotemButton
                    color="primary"
                    @click="exportCourse"
                    class="-margin-left"
                    :label="$t('ExportCourse.export')"
                />
            </div>
        </div>
     </modal>
</template>

<script>
import { mapGetters } from 'vuex'
 export default {
     name: 'modal-export-lsp-content',
     props: {
         course: Object
     },
     data () {
         return {
             selectedExportFormat: '',
             selectedExportLanguage: '',
             zipFile: null
         }
     },
     computed: {
         ...mapGetters({
             selectedCountryCode: 'Languages/getSelectedCountryCode',
             lspSupportedFormats: 'Courses/getLspSupportedFormats',
             lspSupportedLanguages: 'Courses/getLspSupportedLanguages',
             lspExportErrors: 'Courses/getLspExportErrors'
         }),
        getLanguageTranslation () {
            return (language) => {
                return this.$t(`LspLanguages.${language}`)
            }
        },
         defaultExportFormat () {
             return this.lspSupportedFormats[0]?.slug
         }
     },
     methods: {
         changeExportFormatValue (newValue) {
             this.selectedExportFormat = newValue;
         },
         changeExportLanguageValue (newValue) {
             this.selectedExportLanguage = newValue;
         },
         async exportCourse () {
             try {
                 const response = await this.$store.dispatch('Courses/downloadLspFile', {
                     courseId: this.course.id,
                     courseTitle: this.course.title,
                     language: this.selectedExportLanguage,
                     format: this.selectedExportFormat
                 })
             } catch (err) {
                 console.log(err)
             }
         },
         hideModal () {
             this.$modal.hide('export-lsp-content')
         },
         clearError () {
             this.$store.dispatch('Courses/setLspExportErrors', [])
         },
         showNotification () {
             const exportCourseTemplate = (
                 <div class="export-lsp-content__toast-container">
                     <span class="icon-download"></span>
                     <h3 class="export-lsp-content__toast-title">
                         {this.decodeHtmlEntities(this.$t('ExportCourse.notification_message'))}
                     </h3>
                 </div>
             )
             this.$toast(exportCourseTemplate, {
                 position: 'top-right',
                 timeout: 7000,
                 closeOnClick: true,
                 pauseOnFocusLoss: true,
                 pauseOnHover: true,
                 draggable: true,
                 draggablePercent: 0.6,
                 showCloseButtonOnHover: false,
                 hideProgressBar: true,
                 closeButton: false,
                 rtl: false,
                 icon: false,
                 toastClassName: 'export-lsp-toast'
             })
         },
         decodeHtmlEntities (text) {
            const parser = new DOMParser()
            const decodedString = parser.parseFromString(text, 'text/html').body.textContent
            return decodedString
        }
     },
     watch: {
         lspExportErrors (newVal, oldVal) {
             if (newVal?.length === 0) {
                 this.$modal.hide('export-lsp-content')
                 this.showNotification()
             }
         },
         defaultExportFormat(newVal, oldVal) {
             this.selectedExportFormat = newVal
         },
         selectedCountryCode(newVal, oldVal) {
             this.selectedExportLanguage = newVal
         }
     },
     mounted () {
         this.selectedExportFormat = this.defaultExportFormat
         this.selectedExportLanguage = this.selectedCountryCode
     },
     beforeDestroy () {
         this.clearError()
     }
 }
 </script>

<style lang="scss" scoped>
    .export-lsp-content {
        padding: 30px;

        .icon-download {
            font-weight: bold;
            display: flex;
            width: 24px;
            height: 24px;
            justify-content: center;
            align-items: center;
        }

        &__header {
            display: flex;
            align-items: center;
            margin: 0 0 30px;
            gap: 10px;

        }

        &__list {
            font-family: PlusJakartaSans-ExtraBold, sans-serif;
            font-size: 1.6rem;
            padding-inline-start: 20px;
            margin: 0;
        }

        &__list-item {
            margin: 0 0 0 -18px;
        }

        &__title {
            font-family: PlusJakartaSans-Bold, sans-serif;
            font-size: 2rem;
            color: $dark_grey;
            display: flex;
            align-items: center;
        }

        &__subtitle {
            font-family: PlusJakartaSans-ExtraBold, sans-serif;
            font-size: 1.6rem;
            margin: 0 0 16px;
        }

        &__description {
            font-family: PlusJakartaSans-Regular, sans-serif;
            font-size: 1.6rem;
            margin: 0 0 16px;
            display: flex;
        }

        &__icon {
            margin: 0 10px 0 0;
        }

        &__radio-list {
            font-family: PlusJakartaSans-Regular, sans-serif;
            font-size: 1.6rem;
            margin: 0 0 30px;

            li {
                margin: 0 0 16px;
            }
        }

        &__buttons {
            display: flex;
            margin: 20px 0 0;
            justify-content: flex-end;
        }

        &__error {
            background-color: $light_red;
            border: 1px solid $sanguine_brown;
            border-radius: 4px;
            padding: 20px;
            margin: 0 0 30px;
            font-size: 1.6rem;
            color: $sanguine_brown;
        }

        &__error-title {
            font-family: PlusJakartaSans-ExtraBold, sans-serif;
            margin: 0 0 10px 25px;
            display: block;
            position: relative;
            text-transform: capitalize;

            &:before {
                content: '\e941';
                font-family: 'icomoon';
                color: $sanguine_brown;
                margin: 0 10px 0 0;
                position: absolute;
                left: -25px;
            }
        }

        &__toast-container {
            background: $green;
            margin: 0 60px 0 0;
            display: flex;
            width: 240px;
            max-width: 300px;
            padding: 10px 10px 20px 10px;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            border-radius: 20px;
            color: #000000;
        }

        .Vue-Toastification__toast {
            background-color: transparent !important;
            box-shadow: none !important;
            border-left: none !important;
        }


        &__toast-title {
            font-family: PlusJakartaSans, sans-serif;
            font-size: 1.7rem;
            color: #000000;

            span  {
                margin: 0 10px 0 0;
            }
        }

        ::v-deep(.export-lsp-content__radio-list input[type="radio"]:checked + .radio__tick::before) {
            background-color: $science_blue !important;
        }
    }
</style>

<style lang="scss">
[data-modal=export-lsp-content] {
    .v--modal-box.v--modal {
        border-radius: 5px !important;
    }
}
.export-lsp-toast.Vue-Toastification__toast {
    background-color: transparent !important;
    box-shadow: none !important;
    border-left: none !important;
    padding: 0 !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
}
</style>
